import * as yup from 'yup';

// export const validateRowSchema = yup.object().shape({
//     slotName: yup
//         .string()
//         .required('Required'),
//     slotSequence: yup
//         .number()
//         .typeError("Only number")
//         .required('Required')
//         .test(
//             "is-positive",
//             "Please enter a positive number",
//             (value) => value >= 0 && 1 / value !== -Infinity),
// })

export const validationSchema = yup.object({
    rackName: yup
        .string()
        .required('Required'),
    sequence: yup
        .number()
        .typeError("Only number")
        .required('Required')
        .test(
            "is-positive",
            "Please enter a positive number",
            (value) => value >= 0 && 1 / value !== -Infinity),
    // rows: yup.array().of(validateRowSchema)
})

// export const initialRowValues = {
//     slotName: "",
//     slotId: "",
//     slotSequence: "",
//     slotStatus: false,
//     defaultSlot: false
// }

export const initialValues = {
    locationId: "",
    rackName: "",
    sequence: "",
    status: true,
    defaultStatus: false,
    rackType: false
    // rows: [initialRowValues]
}

// export const validationSchema = yup.object({
//     rackName: yup
//         .string()
//         .required('Required'),
//     sequence: yup
//         .string()
//         .required('Required'),
//     slotName: yup
//         .string()
//         .required('Required'),
//     slotSequence: yup
//         .string()
//         .required('Required'),
//     // slotStatus: yup
//     //     .required('Required'),
//     // defaultSlot: yup
//     //     .required('Required')
// })

// export const initialValues = {
//     rackName: "",
//     sequence: "",
//     status: false,
//     defaultStatus: false,
//     slotName: "",
//     slotSequence: "",
//     slotStatus: false,
//     defaultSlot: false
// }